<div (keydown.enter)="validacion()">
    <!-- <h5 mat-dialog-title align="center">Iniciar Sesión</h5>  -->
    <span mat-dialog-title  class="title"><img src="assets/img/realgis_icono.ico" alt="logo"
            class="icon">Iniciar Sesión</span>
    <mat-dialog-content class="login">
        <mat-form-field>
            <input matInput [disabled]="false" placeholder="Usuario" [(ngModel)]="user">
            <mat-icon matPrefix style="margin-right: 5px;">person</mat-icon>
        </mat-form-field>
        <mat-form-field>
            <mat-icon matPrefix style="margin-right: 5px;">lock</mat-icon>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="Contraseña" [(ngModel)]="pass">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button type="submit" (click)="validacion()" style="margin: auto;"><mat-icon matPrefix
                style="margin-right: 5px;">login</mat-icon>Ingresar</button>
    </mat-dialog-actions>
</div>